import type { FaireProductEntity } from "../../entity_types/product";

export const p_bwhsgx2eac: FaireProductEntity = {
  token: "p_bwhsgx2eac",
  type: "product",
  name: "Christmas Cocktails Tea Towel",
  brandToken: "b_9n6zhnblbf",
  brandName: "Geometry",
  imageUrl:
    "https://cdn.faire.com/fastly/f2fd2f0cc04ecfb871d9edb87126042bd208605e909313b21d66798673bf121d.jpeg",
  galleryImageUrls: [],
  priceDollars: 9,
  description:
    'Kitchen Tea Towel\n\nThrow in the (ordinary) towel.\n\nMeet the product that started it all. The Geometry House Tea Towel is a cult favorite for a reason. Created from a tightly-woven Geoweave™ fabric that is ultra-absorbent, quick-drying and never wrinkles, this towel is built to work – while looking like a dream.\n\nSKU: TT-MF-christmas-cocktails\nGTIN/UPC: 00840392766760\n\n• ♺ Made from post-consumer recycled materials\n• 18" x 30"\n• Single-sided print\n\nChore responsibly.\n\nFrom drying dishes to wiping up spills to accenting your kitchen with the season’s most enchanting prints, this Tea Towel does it all – without a negative impact on the environment. Our towels are created from post-consumer recycled products using less water than traditional methods and minimizing our carbon footprint. And due to its patented weave, high absorbency and quick dry time, you can clean with fewer harsh chemicals and wash it less often, reducing yours.\n\nImpact your home, not the environment. Discover the Geometry Tea Towel.',
  tags: [],
  msrpDollars: 18,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:52:22.109Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
